import {FC, useMemo} from 'react';
import {useSelector} from 'react-redux';
import WarningIcon from '../../../assets/images/warning.svg';
import {ChainId, switchNetwork} from '../../../lib/chains';
import {selectWallet} from '../../../redux/wallet.slice';
import walletService, {Connector} from '../../../services/wallet.service';
import useProjectById from '../../hooks/useProjectById';
import {chainsConfig} from '../connect-modal/connect-modal';
import {SelectItem, Selector} from '../selector/selector';

type TProps = {
  projectId: string;
  className?: string;
};

const ChainSelector: FC<TProps> = ({className, projectId}) => {
  const {chainId, address} = useSelector(selectWallet);
  const {project} = useProjectById(projectId);

  const onSelect = (selected: SelectItem) => {
    switchNetwork(selected.value as ChainId);
  };

  const disabled = useMemo(() => {
    if (!address || walletService.connectorCache === Connector.WalletConnect) {
      return true;
    }
    return false;
  }, [address]);

  const chainsList = useMemo(() => {
    return chainsConfig
      .filter(el =>
        project?.projectExternals
          ?.filter(el1 => el1.isActive)
          .map(el1 => el1.network?.symbol)
          .includes(el.symbol),
      )
      .map(({title, icon, id}) => ({
        renderValue: title,
        icon,
        value: id,
      }))
      .sort(a => (a.value === chainId ? -1 : 1));
  }, [chainId, project]);

  const selectedChain: SelectItem = useMemo(() => {
    let result = chainsList.find(({value}) => value === chainId);
    if (!result) {
      result = {
        renderValue: 'Network',
        icon: WarningIcon,
        value: 0,
      };
    }
    return result;
  }, [chainId, chainsList]);

  return (
    <Selector
      className={className}
      selected={selectedChain}
      list={chainsList}
      onSelect={onSelect}
      disabled={disabled}
    />
  );
};

export default ChainSelector;
